/**
 * Exceldownload working with NSWOW2 Tables
 */
class XTableNamer {
  constructor() {

    const elements = Array.prototype.slice.call(document.querySelectorAll('.content .ns-table-wrap, .content .ns-title-h1, .content .mms-title-h1, .content .ns-title-h2, .content .mms-title-h2, .content .accordion-title-type-h3, .content .mms-title-h3'));

    let h1;
    let h2;
    let h3;
    let c;
    const pageTitle = document.querySelector('.header__top-title');

    elements.forEach(element => {
      const className = element.classList[0];

      switch (className) {
        case "mms-title-h1":
          const span = element;
          if (!!span) {
            h1 = span.innerText;
          }
          c = 0;
          break;
        case "mms-title-h2":
          if (!!element.innerText.trim()) {
            h2 = element.innerText;
            c = 0;
          }
          break;
        case "mms-title-h3":
          if (!!element.innerText.trim()) {
            h3 = element.innerText;
            c = 0;
          }
          break;
        case "accordion-title-type-h3":
          if (!!element.innerText.trim()) {
            h2 = element.innerText;
            c = 0;
          }
          break;
        case "ns-table-wrap":
          let title = '';
          let fileTitle = '';

          if (!!pageTitle) {
            title += pageTitle.innerText + ' – ';
          }
          if (!!h1) {
            title += h1.trim();
            fileTitle += title;
          }
          if (!!h2) {
            title += h2.trim();
            fileTitle += h2.trim().replace(/\s/g, '_').substring(3);
          }

          if (!!h3) {
            title += h3.trim();
            fileTitle += h3.trim().replace(/\s/g, '_').substring(3);
          } else {
            fileTitle += 'excel';
            title += ' ' + (c + 1);
          }

          if (c > 0) {
            title += ' ' + (c + 1);
            fileTitle += '_' + (c + 1);
          }

          element.dataset.xTitle = title;
          element.dataset.xFileTitle = fileTitle;
          c++;
          break;
      }
      // ifelement.
    });
  }
}

export default XTableNamer;
